import { makeStyles, tokens } from "@fluentui/react-components";
export const useAtMentionPickerStyles = makeStyles({
    popoverSurface: {
        padding: 0
    },
    title: {
        margin: `${tokens.spacingVerticalMNudge} ${tokens.spacingHorizontalXL}`
    },
    userListItem: {
        margin: `${tokens.spacingVerticalXXS} 0`,
        padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalXL}`,
        color: tokens.colorNeutralForeground1,
        cursor: "pointer",
        ":hover": {
            color: tokens.colorNeutralForeground1Hover,
            backgroundColor: tokens.colorNeutralBackground1Hover
        }
    },
    highlightedListItem: {
        color: tokens.colorNeutralForeground1Selected,
        backgroundColor: tokens.colorNeutralBackground1Selected,
        border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralForeground1Selected}`
    },
    noUsersMessage: {
        padding: `${tokens.spacingVerticalMNudge} ${tokens.spacingHorizontalXL}`,
        color: tokens.colorNeutralForeground3,
        textAlign: "center"
    }
});
